module.exports = __webpack_public_path__ + "static/media/tannico_logo.d3e66c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tannico_logo.png
// module id = 745
// module chunks = 0